export const ENDPOINT = process.env.REACT_APP_API_ENDPOINT

export const RESPONSE_MESSAGE = {
  SUCCESS: 'บันทึกข้อมูลสำเร็จ',
  FAIL: 'บันทึกข้อมูลไม่สำเร็จ'
}

export const HERO_TYPE = [
  'RECYCLE_SHOP',
  'SCOOTER',
  'DROP_POINT',
  'POSTAL',
  'CIRCULAR_BIN',
  'FACTORY'
]

export const STATUS = [
  'PENDING',
  'REGISTERED',
  'APPROVED',
  'SUSPENDED',
  'SUGGEST',
  'DELETED'
]

export const APPUSERS_STATUS = [
  'ENABLED',
  'DEACTIVATE',
]

export const CATEGORY = [
  'หมวดกระดาษ',
  'หมวดพลาสติก',
  'หมวดโลหะ',
  'หมวดแก้ว',
  'หมวด e-waste',
  'หมวดเหล็ก',
  'หมวดอื่นๆ'
]

export const UNIT = [
  'KG',
  'BOX',
  'PIECE',
  'LITER',
  'OTHER'
]

export const ROLE = [
  'ADMIN',
  'USER'
]
export const DATE = {
  FORMAT: 'YYYY-MM-DD'
}

export const ACTION = {
  CREATE: 'Create',
  UPDATE: 'Update'
}

export const POINTACTION = [
  'ค้นพบสินค้าใหม่',
  'เพิ่มวิธีคัดแยก',
  'แนะนำฮีโร่ใหม่'
]

export const ANNOUNCEMENT_STATUS = {
  ON_ANNOUNCE: 'กำลังประกาศหาผู้รับ',
  EXP_ANNOUNCE: 'เมื่อหมดอายุ(48 ชม.)',
  HERO_REQUEST_ANNOUNCE: 'ผู้รับยื่นข้อเสนอ',
  USER_ACCEPT_ANNOUNCE: 'ผู้ใช้รับข้อเสนอ',
  USER_CONFIRM_SENT: 'ผู้ใช้ยืนยันส่งต่อ',
  USER_REJECTED: 'ผู้ใช้ยกเลิกส่งต่อ',
  HERO_REJECTED: 'ผู้รับยกเลิกส่งต่อ',
  HERO_OFFERED: 'ส่งต่อสำเร็จ',
  DELETE: 'ลบ (กดยกเยิก การประกาศ)',
  EXPIRED: 'หมดอายุ',
  CANCELED_HERO: 'ถูกยกเลิกโดยฮีโร่',
  CANCELED_USER: 'ถูกยกเลิกโดยผู้ใช้'
}

export const TRANSACTION_STATUS = {
  USER_REJECTED: 'ผู้ใช้กดยกเลิก',
  USER_KEEP_BIN: 'สินค้าเก็บในถัง',
  USER_DELETE_BIN: 'สินค้าลบออกจากถัง',
  SUCCESS_PENDING: 'ส่งต่อให้ฮีโร่',
  SUCCESS_HEROCONFIRM: 'ฮีโร่ยืนยันการส่งต่อ'
}

export const HERO_TYPE_MESSAGE = {
  RECYCLE_SHOP: 'ร้านรับซื้อของเก่า',
  SCOOTER: 'รถรับซื้อของเก่า',
  DROP_POINT: 'จุดรับบริจาค',
  POSTAL: 'ส่งทางพัสดุ',
  FACTORY: 'โรงงานรีไซเคิล'
}


export const REWARD_CATAGORY = [
  'สินค้า',
  'ส่วนลด',
  'บริจาค',
  'แลกลุ้น'
]

export const REDEEM_STATUS = {
  DONE: 'จัดส่งเรียบร้อย',
  WAITING: 'อยู่ในระหว่างการจัดส่ง',
  CANCEL: 'ยกเลิก'
}

export const EQUIPMENT_CATEGORY = [
  'หมวดเครื่องชั่ง',
  'หมวดเครื่องอัด',
  'หมวดเครื่องจักร',
  'หมวดรถ',
  'หมวดเครื่องมือ',
  'หมวดอุปกรณ์สิ้นเปลือง',
  'หมวดอุปกรณ์สำนักงาน',
  'หมวดอื่นๆ'
]



// WEBPACK FOOTER //
// ./src/utils/constants.js